<template>
  <div class="product">
    <!-- banner -->
    <banner :type='activeName == "1" ? "4" : "5"'/>
    <!-- 导航栏 -->
    <div v-if="width >= 1200" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="心智谷" name="1">
        </el-tab-pane>
        <el-tab-pane label="心理+" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="width <= 768" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="心智谷" name="1">
        </el-tab-pane>
        <el-tab-pane label="心理+" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- pc -->
    <div v-if="width >= 1200">
      <div class="body">
        <!-- 心智谷背景 -->
        <div v-if="activeName == 1" id="society" class="society">
          <div class="title">心智谷背景</div>
          <!--                        <p style="font-size:18px;color:#666666;">{{ background.description }}</p>-->
          <div>
            <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="background.description"></p>
          </div>
          <div class="societyTop">
            <img :src="imgserver + orientation.picture" alt="" style="border-radius: 10px;height: 284px;">
            <div class="topContent">心智谷定位</div>
            <div class="content">
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="orientation.description"></p>
            </div>
          </div>
        </div>
        <!-- 规划 -->
        <div v-if="activeName == 1" class="plan">
          <div class="title eTitle">心智谷规划</div>
          <div style="cursor: pointer;">
            <span :style="{color:showLight == 1 ? '#333333' :'#999999'}" class="span"
                  style="padding-right:30px;font-weight:700;font-size: 18px !important"
                  @click="light(1)">社会功能区</span>
            <span :style="{color:showLight == 2 ? '#333333' :'#999999'}" class="span" style="font-weight:700;font-size: 18px !important"
                  @click="light(2)">产业功能区</span>
          </div>
          <div v-if="showLight == 1" class="planBody">
            <img :src="imgserver + planCommunity.picture" alt="" style="border-radius: 10px">
            <div class="right">
              <div class="top" style="cursor: pointer;">社会功能区</div>
              <div class="lines"></div>
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="planCommunity.description"></p>
              <!-- <el-button round>了解更多</el-button> -->
            </div>
          </div>
          <div v-if="showLight == 2" class="planBody">
            <img :src="imgserver + planIndustry.picture" alt="" style="border-radius: 10px">
            <div class="right">
              <div class="top" style="cursor: pointer;">产业功能区</div>
              <div class="lines"></div>
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="planIndustry.description"></p>
              <!-- <el-button round>了解更多</el-button> -->
            </div>
          </div>
        </div>
        <!-- 社会效益 -->
        <div v-if="activeName == 1" class="benefit">
          <div class="benefitleft">
            <div style="font-size: 24px;font-weight: 500;color:#333;">{{ active == 1 ? '社会效益' : '经济效益' }}</div>
            <div class="line"></div>
            <div v-if="active == 1" style="display:flex;align-items:center;">
              <div class="row"></div>
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;"
                 v-html="vistaCommunity.description"></p>
            </div>
            <div v-if="active == 2" style="display:flex;align-items:center;">
              <div class="row"></div>
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;"
                 v-html="vistaEconomics.description"></p>
            </div>
          </div>
          <div class="imgbox">
            <img v-if="active == 1" :src="imgserver + vistaCommunity.picture" alt="" style="border-radius: 10px">
            <img v-if="active == 2" :src="imgserver + vistaEconomics.picture" alt="" style="border-radius: 10px">
            <div class="imgtitle">心智谷前景</div>
            <div class="imgtab">
              <div :class="active == 1 ? 'bottoms': 'bottom'" @click="clickHandler('1')">社会效益</div>
              <div :class="active == 2 ? 'bottoms': 'bottom'" @click="clickHandler('2')">经济效益</div>
            </div>
            <!-- <img class="toparrow" src="../assets/img/up.png" alt="">
            <img class="bottomarrow" src="../assets/img/down.png" alt=""> -->
          </div>
        </div>
        <!-- 理念 -->
        <div v-if="activeName == 2" class="idea">
          <div class="title">理念</div>
          <p class="ql-editor ql-container ql-snow" style="white-space:pre;color:#666666;"
             v-html="idea.description"></p>
          <div class="ideaTop">
            <div class="top" style="width:50%">
              <div class="title eTitle">模式</div>
              <p class="titleFontSize">心理学和心理健康产业可与多学科、多行业交叉发展。</p>
              <div class="line"></div>
<!--              <div>-->
<!--                &lt;!&ndash; <div v-for="item in ideaList" :key="item.id" style="margin-top:30px">-->
<!--                     <span class="idList" v-for="(items,index) in item.list" :key="index">{{ items.title }}</span>-->
<!--                </div> &ndash;&gt;-->
<!--                <div style="margin-top:30px">-->
<!--                  <span v-for="(items,index) in patternList1" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div style="margin-top:30px">-->
<!--                  <span v-for="(items,index) in patternList2" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div style="margin-top:30px">-->
<!--                  <span v-for="(items,index) in patternList3" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div style="margin-top:30px">-->
<!--                  <span v-for="(items,index) in patternList4" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--              </div>-->
              <div class=" ql-editor ql-container ql-snow">
                <div v-html="patternList1"></div>
              </div>
            </div>
            <img :src="imgserver + idea.picture" alt="" style="border-radius: 10px">
          </div>
        </div>
      </div>
      <div v-if="activeName == 2" class="bottomText">
        <img :src="imgserver + vista.picture" alt="" style="border-radius: 10px">
        <div class="text">
          <div class="tttt">
            <div style="font-size:24px;margin-top:50px;">前景</div>
            <div style="margin-top:30px">
              <p class="ql-editor ql-container ql-snow" style="white-space:pre;color:#666666;"
                 v-html="vista.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-if="width <= 768">
      <!-- 心智谷背景 -->
      <div v-if="activeName == 1" id="society" class="society">
        <div class="etitle">心智谷背景</div>
        <!--                <p style="color:#666666;">{{  }}</p>-->
        <p class="ql-editor ql-container ql-snow" style="white-space:pre;font-size: 8px;font-weight: normal"
           v-html="background.description"></p>
        <div class="societyTop">
          <img :src="imgserver + background.picture" alt="" style="border-radius: 10px">
          <div class="topContent">心智谷定位</div>

          <div class="content">
            <p class="ql-editor ql-container ql-snow" style="white-space:pre;font-size: 8px;font-weight: normal"
               v-html="orientation.description"></p>
          </div>
        </div>
      </div>
      <!-- 规划 -->
      <div v-if="activeName == 1" class="plan">
        <div class="etitle">心智谷规划</div>
        <div style="font-size: 18px !important;">
          <span :style="{color:showLight == 1 ? '#333333' :'#999999'}" class="span"
                style="padding-right:30px;font-weight:700;;"
                @click="light(1)">社会功能区</span>
          <span :style="{color:showLight == 2 ? '#333333' :'#999999'}" class="span" style="font-weight:700;font-size: 18px !important;"
                @click="light(2)">产业功能区</span>
        </div>
        <div v-if="showLight == 1" class="planBody">
          <img :src="imgserver + planCommunity.picture" alt="" style="border-radius: 10px">
          <div class="right">
            <div class="top">社会功能区</div>
            <div class="lines"></div>
            <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="planCommunity.description"></p>
            <!-- <el-button round>了解更多</el-button> -->
          </div>
        </div>
        <div v-if="showLight == 2" class="planBody">
          <img :src="imgserver + planIndustry.picture" alt="" style="border-radius: 10px">
          <div class="right">
            <div class="top">产业功能区</div>
            <div class="lines"></div>
            <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="planIndustry.description"></p>
            <!-- <el-button round>了解更多</el-button> -->
          </div>
        </div>
      </div>
      <!-- 社会效益 -->
      <div v-if="activeName == 1" class="benefit">
        <div class="etitle">心智谷规划</div>
        <!-- 社会效益 -->
        <div class="benefitleft">
          <img :src="imgserver + vistaCommunity.picture" alt="" style="border-radius: 10px">
          <div class="bottoms" @click="clickHandler('1')">社会效益</div>
          <p class="ql-editor ql-container ql-snow" v-html="vistaCommunity.description"></p>
        </div>
        <!-- 经济效益 -->
        <div class="benefitleft">
          <img :src="imgserver + vistaEconomics.picture" alt="" style="border-radius: 10px">
          <div class="bottoms" @click="clickHandler('1')">经济效益</div>
          <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="vistaEconomics.description"></p>
        </div>
      </div>
      <!-- 理念 -->
      <div v-if="activeName == 2" class="idea">
        <div class="etitle">理念</div>
        <p class="ql-editor ql-container ql-snow" style="white-space:pre;" v-html="idea.description"></p>
        <div class="ideaTop">
          <div class="top" style="width:100%">
            <div class="etitle">模式</div>
            <p style="font-size: 18px;text-align:center">心理学和心理健康产业可与多学科、多行业交叉发展。</p>
            <div style="display:flex; justify-content: space-around;">
<!--              <div>-->
<!--                <div style="margin-top:20px">-->
<!--                  <span v-for="(items,index) in patternList1" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <span v-for="(items,index) in patternList2" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <span v-for="(items,index) in patternList3" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <span v-for="(items,index) in patternList4" :key="index" class="idList">{{ items }}</span>-->
<!--                </div>-->

<!--              </div>-->
              <div class=" ql-editor ql-container ql-snow">
                <div v-html="patternList1"></div>
              </div>

              <img :src="imgserver + idea.picture" alt="" style="border-radius: 10px">
            </div>
          </div>

        </div>
      </div>
      <!-- 前景 -->
      <div v-if="activeName == 2" class="bottomText">
        <img :src="imgserver + vista.picture" alt="" style="border-radius: 10px">
        <div class="text">
          <div class="tttt">
            <div style="margin-bottom:5px;font-size: 18px;font-weight:700;margin-top:10px">前景</div>
            <p class="ql-editor ql-container ql-snow" style="white-space:pre;margin-top:0px"
               v-html="vista.description"></p>
          </div>
        </div>
      </div>
    </div>


    <!-- 联系方式 -->
    <contact></contact>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Contact from "../components/contact.vue"
import {getindustrySystem, getindustrySystemAdd} from "../api/api"

export default {
  data() {
    return {
      vistaPic: "",
      activeName: "1",
      active: '1',
      benList: [
        {
          text: "建立“应用心理学科研成果转化中心”，打造心理服务实践应用高地，形成先进模式向全国推广。"
        },
        {
          text: "聚焦心理学前沿理论成果，构建“全国心理学会议中心”，打造中国心理学界的“博鳌论坛”。"
        },
        {
          text: "打造“心理科技和心理装备固定交易市场”，形成全国心理服务、装备研发、生产、交易中心。"
        },
        {
          text: "建设全国首个综合性心理服务基地、心理学科技艺术馆、心理安全科普体验馆、青少年心理科普体验训练研学游基地，形成可向全国推广的经验和模式。"
        }

      ],
      benListTwo: [
        {
          text: "以“心智谷”建设为载体，立足山东、辐射全国，延伸产业链，打造心理产业集群，引领经济新业态，打造国家心理产业旗舰，成为全国心理健康产业发展的“制高点”和“创新源泉”。"
        },


      ],
      showLight: 1,
      ideaList: [
        {
          id: 1,
          list: [
            {title: "心理+科普"},
            {title: "心理+教育"},
          ]
        },
        {
          id: 2,
          list: [
            {title: "心理+HR"},
            {title: "心理+AI"},
            {title: "心理+睡眠"},
          ]
        },
        {
          id: 3,
          list: [
            {title: "心理+康养"},
            {title: "心理+文创"},
            {title: "心理+会展"},
          ]
        },
        {
          id: 4,
          list: [
            {title: "心理+研学"},
            {title: "心理+标准"},
            {title: "心理+互联网"},
            {title: "心理+智能制造"},
          ]
        },
      ],
      background: {},
      planCommunity: {}, //社会
      planIndustry: {}, //产业
      vistaCommunity: {},//社会效益
      vistaEconomics: {},//经济效益
      orientation: {},
      idea: {},
      patternList1: [],
      patternList2: [],
      patternList3: [],
      patternList4: [],
      vista: {},
      type: '4',
      width: document.body.clientWidth
    };
  },
  components: {
    Banner,
    Contact
  },
  watch: {
    width(val) {
      console.log('实时屏幕宽度：', val, this.width)
    }
  },
  mounted() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName
      if (this.activeName == 1) {
        // this.activeName = 1
        getindustrySystem().then(res => {
          this.background = res.data.data.background
          this.planCommunity = res.data.data.planCommunity
          this.planIndustry = res.data.data.planIndustry
          this.vistaCommunity = res.data.data.vistaCommunity
          this.vistaEconomics = res.data.data.vistaEconomics
        })
      } else {
        // this.activeName = 2
        getindustrySystemAdd().then(res => {

          this.idea = res.data.data.idea
          this.patternList1 = res.data.data.patternList1
          console.log(res,'asdasdas')
          this.vistaPic = "http://ryxy.weishulink.com" + this.vista.picture
        })
      }

    }
    let that = this
    window.addEventListener("resize", function (e) {
      that.width = e.target.document.documentElement.clientWidth
    });
    // console.log(this.type,'type');
    getindustrySystem().then(res => {
      this.background = res.data.data.background
      this.planCommunity = res.data.data.planCommunity
      this.planIndustry = res.data.data.planIndustry
      this.vistaCommunity = res.data.data.vistaCommunity
      this.vistaEconomics = res.data.data.vistaEconomics
      this.orientation = res.data.data.orientation
    })
  },
  methods: {
    // 滑动到指定位置
    handleClick(tab) {
      //   if (tab.name == 1) {
      //       document.getElementById("society").scrollIntoView({ behavior: 'smooth' })
      //   } else if (tab.name == 2){
      //       document.getElementById("school").scrollIntoView({ behavior: 'smooth' })
      //   } else if (tab.name == 3){
      //       document.getElementById("eap").scrollIntoView({ behavior: 'smooth' })
      //   } else if (tab.name == 4){
      //       document.getElementById("social").scrollIntoView({ behavior: 'smooth' })
      //   }
      if (tab.name == 1) {
        // this.activeName = 1
        getindustrySystem().then(res => {
          this.background = res.data.data.background
          this.planCommunity = res.data.data.planCommunity
          this.planIndustry = res.data.data.planIndustry
          this.vistaCommunity = res.data.data.vistaCommunity
          this.vistaEconomics = res.data.data.vistaEconomics
        })
      } else {
        // this.activeName = 2
        getindustrySystemAdd().then(res => {

          this.idea = res.data.data.idea
          console.log(this.imgserver + this.idea.picture, 'iiiimmgsh');
          this.patternList1 = res.data.data.patternList1
          this.vista = res.data.data.vista
          this.vistaPic = "http://ryxy.weishulink.com" + this.vista.picture
        })
      }
    },
    clickHandler(i) {
      this.active = i
    },
    light(i) {
      this.showLight = i
    }


  }
};
</script>

<style lang="scss" scoped>
@import url('../assets/font/font.css');

* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
  font-size: 16px;
}

.product {
  width: 100%;
  height: 100%;
}

.body {
  width: 1440px;
  margin: 0 auto;
}

::v-deep .el-tabs__item {
  color: #666666 !important;
}

//公共样式
.title,
.eTitle {
  font-size: 30px;
  font-weight: 700;
  line-height: 50px;
  letter-spacing: 0px;
  color: #333333;
  margin-bottom: 50px;
  text-align: center;
}

.eTitle {
  font-size: 30px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 20px;
  //   padding: 10px 0;
}

//改tab
.nav {
  width: 100%;
  // padding: 20px 0 0 0;
  height: 50px;
  line-height: 50px;
  box-shadow: 0px 4px 10px 0px #E9F5F9;
  margin-bottom: 20px;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none !important;
  background-color: #fff !important;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
}

::v-deep .el-tabs__nav-scroll {
  width: 1440px;
  margin: 0 auto;
}

//结束
::v-deep .el-tabs--card {
  border: 0 !important;
}

::v-deep .el-tabs__item .is-active {
  color: #34A59A !important;
}

::v-deep .el-tabs__item:hover {
  color: #333333 !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #fff !important;
  color: #34A59A !important;
  border-bottom-color: transparent !important;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

@media (min-width: 1200px) {
  //社会心理服务
  .society {
    width: 1440px;
    box-sizing: border-box;
    padding: 70px 0;
    margin: 0 auto;

    .societyTop {
      width: 100%;
      // height: 45%;
      margin-top: 30px;
      position: relative;

      img {
        width: 100%;
        // height: 100%;
      }
    }

    .topContent {
      position: absolute;
      z-index: 100;
      top: 65px;
      left: 50px;
      color: #fff;
      font-size: 24px;
      font-weight: 700;
      line-height: 35px;

    }

    .content {
      position: absolute;
      z-index: 100;
      top: 120px;
      //   bottom: 90px;
      left: 50px;
      color: #fff;
      width: 500px;

    }
  }
  .line {
    width: 47px;
    height: 4px;
    box-sizing: border-box;
    border-width: 0px 0px 4px 0px;
    border-style: solid;
    border-color: #238B81;
    margin: 20px 0;
  }
  .plan {
    width: 100%;
    // height: 550px;
    margin-bottom: 50px;

    .planBody {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;

      img {
        width: 48%;
        height: 350px;
      }

      .right {
        width: 46%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 20px 0;

        .top {
          font-size: 22px;
          font-weight: 500;
          line-height: 50px;
          letter-spacing: 0px;
          color: #333333;
        }

        .lines {
          border: 1px solid #D8D8D8;
          margin: 20px 0;
        }

        p {
          font-weight: normal;
          letter-spacing: 0px;
          color: #666666;
        }
      }

      .el-button.is-round {
        border-color: #3DCDD0;
        color: #3DCDD0;
        margin-top: 50px;
        width: 20%;
      }

      .span {
        font-weight: 700;
      }
    }
  }
  .benefit {
    width: 100%;
    height: 400px;
    background: #F8FBFB;
    margin-top: 80px;
    margin-bottom: 80px;
    display: flex;

    .imgbox {
      width: 35%;
      height: 400px;
      position: relative;
      box-sizing: border-box;

      img {
        width: 100%;
        height: 100%;
      }

      .toparrow {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: 90px;
        left: 40px;
      }

      .bottomarrow {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: 50px;
        left: 40px;
      }
    }

    .benefitleft {
      width: 65%;
      box-sizing: border-box;
      padding: 60px;
    }

    .line {
      width: 47px;
      height: 4px;
      box-sizing: border-box;
      border-width: 0px 0px 4px 0px;
      border-style: solid;
      border-color: #238B81;
      margin: 20px 0;
    }

    p {
      font-weight: normal;
      letter-spacing: 0px;
      color: #666666;
      margin-top: 10px;
    }

    // .row{
    //     display:inline-block;
    //     height:4px;
    //     width:4px;
    //     border-radius: 4px;
    //     background: #666666;
    //     margin-right:10px;
    //     margin-top: 10px;
    // }

    .imgtitle {
      position: absolute;
      top: 60px;
      left: 40px;
      font-size: 30px;
      font-weight: 500;
      line-height: 50px;
      letter-spacing: 0px;
      color: #FFFFFF;
    }

    .imgtab {
      position: absolute;
      top: 120px;
      left: 40px;
      width: 72px;
      // height: 50px;
      font-size: 18px;
      font-weight: 500;
      line-height: 50px;
      letter-spacing: 0px;
      color: #FFFFFF;

    }

    .bottom {
      font-size: 18px;
      font-weight: normal;
      cursor: pointer;
    }

    .bottoms {
      font-size: 18px;
      font-weight: 600;
      border-bottom: 2px solid #fff;
      cursor: pointer;
    }

    .span {
      font-size: 16px;
      // font-weight: 700;
      cursor: pointer;
    }
  }
  //理念
  .idea {
    width: 1440px;
    box-sizing: border-box;
    padding: 70px 0;
    margin: 0 auto;

    .ideaTop {
      width: 100%;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;

      img {
        width: 50%;
      }

      .idList {
        width: 150px;
        display: inline-block;
        // margin-right: 70px;
      }

      .top {
        box-sizing: border-box;
        padding-top: 30px;
        height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .titleFontSize{
          font-size: 24px;
        }
      }
    }
  }
  .bottomText {
    width: 100%;
    height: 392px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  }
  .text {
    width: 1440px;
    margin: 0 auto;
    height: 280px;
    // position: absolute;
    // margin-bottom: 130px
    text-align: center;
    box-sizing: border-box;
    color: #343434;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.4) 100%);
  }
  .tttt {
    width: 1200px;
    margin: 0 auto;
  }
}

@media (max-width: 1200px) {
  .etitle {
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
  }
  .nav {
    width: 100%;
    // padding: 20px 0 0 0;
    height: 50px;
    line-height: 50px !important;
    box-shadow: 0px 4px 10px 0px #E9F5F9;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none !important;
    background-color: #fff !important;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    height: 30px;
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    margin: 0 auto;
  }
  //社会心理服务
  .society {
    //   width: 1440px;
    width: 100%;
    box-sizing: border-box;
    padding: 14px;
    font-size: 12px;
    margin: 0 auto;
    font-weight: 600;

    .societyTop {
      width: 100%;
      // height: 45%;
      margin-top: 20px;
      position: relative;

      img {
        width: 100%;
        height: 160px;
        border-radius: 5px;
        // height: 100%;
      }
    }

    .topContent {
      position: absolute;
      z-index: 100;
      top: 4px;
      left: 15px;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      line-height: 35px;
    }

    .content {
      position: absolute;
      z-index: 100;
      top: 40px;
      //   bottom: 90px;
      left: 15px;
      color: #fff;
      font-size: 8px;
      line-height: 20px;
      width: 298px;
      //   width: 500px;

    }
  }
  .line {
    width: 47px;
    height: 4px;
    box-sizing: border-box;
    border-width: 0px 0px 4px 0px;
    border-style: solid;
    border-color: #238B81;
    margin: 20px 0;
  }
  .plan {
    width: 100%;
    box-sizing: border-box;
    padding: 14px;
    // height: 550px;
    // margin-bottom: 50px;
    .planBody {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      img {
        width: 100%;
        height: 173px;
        border-radius: 5px;
      }

      .right {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 20px 0;

        .top {
          font-size: 16px;
          font-weight: 600;
          // line-height: 50px;
          letter-spacing: 0px;
          color: #333333;
        }

        .lines {
          border: 1px solid #D8D8D8;
          margin: 20px 0;
        }

        p {
          font-weight: 600;
          letter-spacing: 0px;
          color: #666666;
        }
      }

      .el-button.is-round {
        border-color: #3DCDD0;
        color: #3DCDD0;
        margin-top: 50px;
        width: 20%;
      }

      .span {
        font-weight: 700;
      }
    }
  }
  .benefit {
    width: 100%;
    padding: 14px;
    box-sizing: border-box;

    .benefitleft {
      width: 100%;
      height: 320px;
      position: relative;
      margin-bottom: 20px;

      p {
        white-space: pre;
        overflow-y: scroll;
        height: 240px;
        width: 90%
      }

      img {
        width: 100%;
        height: 320px;
      }

      .bottoms {
        position: absolute;
        top: 20px;
        left: 20px;
        font-size: 14px;
        font-weight: 600;
        height: 30px;
        border-bottom: 2px solid #fff;
        cursor: pointer;
        color: #fff;
      }

      p {
        color: #fff;
        position: absolute;
        top: 60px;
        left: 20px;
        width: 90%;
        line-height: 20px;
      }
    }

  }
  //理念
  .idea {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 0;
    margin: 0 auto;

    .ideaTop {
      width: 100%;

      img {
        width: 159px;
        height: 147px;
      }

      .idList {
        font-size: 10px;
        // width: 65px;
        margin-right: 5px;
        display: inline-block;
        // margin-right: 70px;
      }

      .top {
        box-sizing: border-box;
        padding-top: 30px;
        // height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
  .bottomText {
    width: 100%;
    height: 200px;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  }
  .text {
    // width: 1440px;
    // margin: 0 auto;
     height: 200px;
    // position: absolute;
    // margin-bottom: 130px
    text-align: center;
    box-sizing: border-box;
    color: #343434;
    font-size: 10px;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.4) 100%);
  }
  .tttt {
    // width: 1200px;
    width: 347px;
    height: 140px;
    margin: 0 auto;
    z-index: 999;
  }
}
</style>
